<!--
 * @Author: liukai
 * @since: 2022-04-13 17:01:02
 * @LastAuthor: liukai
 * @lastTime: 2022-04-25 10:41:01
-->
<template>
  <div class="henan">
    <!-- <Nav title="河南省新冠肺炎实时动态"></Nav> -->
    <refreshList v-model:freshMap="freshMap" @refresh="onRefresh" @onLoad="onLoad">
      <div class="focus_pic">
        <img :src="pic" alt />
      </div>
      <div class="total_pain">
        <div class="float_hat"></div>
        <h3>河南疫情</h3>
        <div class="pain_list">
          <div class="cell">
            <h5>{{`${overview.addLocalConfirm>0?"+":''}${overview.addLocalConfirm}`}}</h5>
            <p>昨日新增</p>
          </div>
          <div class="cell">
            <h5 class="red">{{overview.aggregateConfirm}}</h5>
            <p>累计确诊</p>
          </div>
          <div class="cell">
            <h5 class="green">{{overview.aggregateCure }}</h5>
            <p>累计治愈</p>
          </div>
          <div class="cell">
            <h5 class="death">{{overview.aggregateDie}}</h5>
            <p>累计死亡</p>
          </div>
        </div>
      </div>
      <div class="maparea">
        <HenanMap :mapdata="mapdata" ref="henanMap"></HenanMap>
        <div class="mapBtn">
          <div :class="['cellbtn', currentIndex==1?'btn_active':'']" @click="handleNow"><p>现存确诊</p></div>
          <div :class="['cellbtn',currentIndex==2?'btn_active':'']" @click="handleTotal"><p>累计确诊</p></div>
        </div>
        <div class="brokemap">
          <Broken :mapdata="chart"></Broken>
        </div>
      </div>
      <div class="list">
        <h3>河南病例</h3>
        <van-row>
          <van-col span="5">
            <span class="area">省市</span>
          </van-col>
          <van-col span="4">
            <span class="area blue">昨日新增</span>
          </van-col>
          <van-col span="5" align="center">
            <span class="area listRed">累计确诊</span>
          </van-col>
          <van-col span="6" align="center">
            <span class="area longer perple">治愈</span>
          </van-col>
          <van-col span="4">
            <span class="area weak">死亡</span>
          </van-col>
        </van-row>
        <template v-for="(item,index) in list" :key="item.id">
          <van-row>
            <van-col span="5">
              <span :class="['area',index%2==0?'triggle':'','table']">{{item.cityName}}</span>
            </van-col>
            <van-col span="4">
              <span :class="['area',index%2==0?'triggle':'','table']">{{item.addConfirm}}</span>
            </van-col>
            <van-col span="5" align="center">
              <span :class="['area',index%2==0?'triggle':'','table']">{{item.aggregateConfirm}}</span>
            </van-col>
            <van-col span="6" align="center">
              <span
                :class="['area',index%2==0?'triggle':'','table','longer']"
              >{{item.aggregateCure}}</span>
            </van-col>
            <van-col span="4">
              <span :class="['area',index%2==0?'triggle':'','table']">{{item.aggregateDie}}</span>
            </van-col>
          </van-row>
        </template>
      </div>
      <div class="news_list">
        <!-- <h3>本地报道</h3> -->
        <template v-for="item in streamArticle" :key="item.id">
          <newsCard :item="item"></newsCard>
        </template>
      </div>
    </refreshList>
  </div>
</template>

<script>
import Nav from "@/components/nav-bar.vue";
import { reactive, onMounted, toRefs, ref } from "vue";
import { Divider, Col, Row } from "vant";
import HenanMap from "@/components/map.vue";
import Broken from "@/components/broken.vue";
import newsCard from "@/components/newsCard.vue";
import { getArticle, getCharts } from "@/api";
import refreshList from "@/components/refreshList.vue";

export default {
  name: "henan",
  components: {
    Nav,
    HenanMap,
    Broken,
    newsCard,
    refreshList,
    [Divider.name]: Divider,
    [Col.name]: Col,
    [Row.name]: Row,
  },
  setup() {
    const henanMap = ref("henanMap");
    const data = reactive({
      pic: require("@/assets/img/henan.jpg"),
      list: [],
      map: {},
      overview: {
        addLocalConfirm: 0,
        aggregateConfirm: 0,
        aggregateCure: 0,
        aggregateDie: 0,
      },
      chart: {},
      testChanel: "1420287272183422977",
      streamArticle: [],
      freshMap: {
        refreshLoad: false,
        listLoading: false,
        listFinished: true,
      },
      pageNo: 1,
      pageSize: 6,
      currentIndex: 1,
      mapdata: [],
    });

    const methodsMap = {
      handleNow: () => {
        data.currentIndex = 1;
        data.mapdata = data.map.existing_confirm;
        // henanMap.renderMap()
      },
      handleTotal: () => {
        data.currentIndex = 2;
        data.mapdata = data.map.aggregate_confirm;
        // henanMap.renderMap()
      },
      requestHenanArticle: (onLoad) => {
        let param = {
          pageNo: data.pageNo,
          pageSize: data.pageSize,
          channelId: "1516957609436643329",
          // channelId: data.testChanel,
        };
        return new Promise((resolve, reject) => {
          getArticle(param)
            .then((res) => {
              console.log(res);
              if (res.data.code == 0) {
                data.freshMap.listLoading = false;
                data.freshMap.listFinished = res.listFinished;
                data.streamArticle = onLoad
                  ? data.streamArticle.concat(res.data.result.content)
                  : res.data.result.content;
                console.log(data.streamArticle, "dataaa");
                if (data.pageNo >= res.data.result.totalPage) {
                  data.freshMap.listFinished = true;
                } else {
                  data.pageNo = res.data.result.pageNo + 1;
                }
              }
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        });
      },
      requestCharts: () => {
        return new Promise((resolve, reject) => {
          getCharts()
            .then((res) => {
              if (res.data.code == 0) {
                let orderList=res.data.data.list;
                orderList.sort((a,b)=>{
                  return b.addConfirm-a.addConfirm
                })

                let {addLocalConfirm,aggregateConfirm,aggregateCure,aggregateDie}=res.data.data.overview
                orderList.unshift({
                  cityName:'河南',
                  addConfirm:addLocalConfirm,
                  aggregateConfirm,
                  aggregateCure,
                  aggregateDie
                })
                  data.list = orderList
                data.map = res.data.data.map;
                data.chart = res.data.data.chart;
                console.log(data.chart, "charts");
                data.overview = res.data.data.overview;
                methodsMap.handleNow();
              }
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        });
      },
      //下拉刷新
      onRefresh: () => {
        data.freshMap.refreshLoad = true;
        data.pageNo = 1;
        Promise.all([
          //获取文章
          // methodsMap.requestHenanArticle(),
          methodsMap.requestCharts(),
          //获取疫情数据
        ]).then(() => {
          data.freshMap.refreshLoad = false;
        });
      },

      // 触底加载
      onLoad: () => {
        // methodsMap.requestHenanArticle(true);
      },
    };
    onMounted(() => {
      // methodsMap.requestHenanArticle()
      methodsMap.requestCharts();
    });
    return {
      henanMap,
      ...toRefs(data),
      ...methodsMap,
    };
  },
};
</script>

<style lang="scss" >
@import "@/css/wap/mixin.scss";
.henan {
  width: 375px;
  background-color: #fff;
  box-sizing: border-box;
  min-height: 100vh;
  .focus_pic {
    img {
      width: 375px;
      height: 210px;
    }
  }
  .total_pain {
    position: relative;
    padding: 15px;
    .float_hat {
      width: 375px;
      height: 20px;
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
      position: absolute;
      top: -12px;
      left: 0;
      background-color: #fff;
    }
    h3 {
      color: #444444;
      font-weight: bold;
      font-size: 16px;
    }
    .sprite {
      width: 345px;
      margin: 0 auto;
    }
    .pain_list {
      margin-top: 16px;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      .cell {
        width: 80.3px;
        height: 64px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        background-color: #f6f7fd;
        overflow: hidden;
        h5 {
          color: #4a5ec7;
          font-weight: bold;
          font-size: 22px;
          width: 80.3px;
          @include noWrap;
          text-align: center;
        }
        p {
          color: #444444;
          font-weight: 500;
          font-size: 12px;
        }

        .red {
          color: #ce2b1d;
        }
        .brown {
          color: #962928;
        }
        .green {
          color: #4ca284;
        }
        .death {
          color: #051839;
        }
      }
      :nth-child(2) {
        background-color: #faf3f3;
      }
      :nth-child(3) {
        background-color: #f3faf8;
      }
      :nth-child(4) {
        background-color: #f1f2f4;
      }
    }
  }
  .maparea {
    width: 375px;
    box-sizing: border-box;
    padding: 15px;
    padding-top: 0;
    .mapBtn {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 15px;
      .cellbtn {
        width: 165px;
        height: 35px;
        background-color: #f6f7fd;
        font-size: 12px;
        font-weight: bold;
        line-height: 35px;
        text-align: center;
        color: #444;
        border-radius: 8px;
        letter-spacing: 1px;
        border: 1px solid #eee;
        position: relative;
      }
      .btn_active {
        border-color: #edcfcf;
        background-color: #faf3f3;
        font-size: 12px;
        color: #444;

        &::before {
          position: absolute;
          left: 77px;
          top: -6px;
          content: "";
          display: inline-block;
          transform: rotate(45deg);
          width: 10px;
          height: 10px;
          border: 1px solid #edcfcf;
          background-color: #faf3f3;
          border-right-color: transparent;
          border-bottom-color: transparent;
        }
      }
    }
    .brokemap {
      width: 343px;
      margin: 30px auto 0 auto;
      border: 1px solid #eee;
      border-radius: 8px;
    }
  }
  .list {
    width: 345px;
    margin: 0 auto;
    padding-bottom: 15px;
    h3 {
      color: #444444;
      font-weight: bold;
      font-size: 16px;
      margin: 6px 0;
    }
    .area {
      display: inline-block;
      height: 36px;
      width: 57px;
      line-height: 36px;
      text-align: center;
      color: #444444;
      font-family: PingFang SC;
      font-weight: 600;
      font-size: 12px;
      width: 100%;
    }
    .longer {
      width: 60px;
    }
    .blue {
      color: #4a5ec7;
    }
    .listRed {
      color: #db2f20;
    }
    .perple {
      color: #ac45cd;
    }
    .weak {
      color: #999999;
    }
    .table {
      font-weight: normal;
    }
    .triggle {
      background-color: #fafafa;
      width: 100%;
    }
  }
  .news_list {
    width: 345px;
    margin: 0 auto;
    padding-bottom: 30px;
    h3 {
      color: #444444;
      font-weight: bold;
      font-size: 16px;
    }
  }
}
</style>